import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LandingService} from "../../services/landing.service";
import {GamePromoModel, LandingModel} from "../../models/landing.model";
import {LanguageService} from "../../services/language.service";
import {ConfigService} from "../../services/config.service";
import {TitleService} from "../../services/title.service";

declare var bootstrap: any;


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent {

  /** dynamic = configurable landings:
   ** from the brand:
   - logo
   - primary color (the "play now" button, highlight color)
   - footer logos: need a list by brand - until that all are the same
   ** from variables: from the url = configurable
   - free spins, free chips, welcome bonus, limit + free bets for sports
   - bitcoin: default to 0 (= 0% extra with any bitcoin deposit)
   - language: default to english + translations(de, fr, it, es, +pt)
   - currency: (default none)
   - bonuscode: CMD20 or undefined - are they changing? if yes, we need a variable in service
   - terms: having or not (later could be variables) --> in modal (more info button in top right corner on desktop) / link under play button on mobile)
   ** needed from graphics: - 1 assets of files for desktop or mobile view
   - a game logo (if it's a game-promoting landing)
   - a promo image with optional flares (for game promos)
   - a background image with optional flares (examples later)

   ** todo
   * - the OLD LANDINGS
   *    - they stay frozen in an outside repo (available but no touch) - ancient links used (done by redirecting)
   *    - if we need to change something, we have to make them in the new design (new graphics needed)
   * - later:
   *    - no gamePromo = only bg landings ex. slotvibe --> general-promo without game
   *        - we use 'keywords' to get the landings: TODO find a more maintainable way to do REFACTOR ALL THIS SHIT
   *            '-offer': for 24 slots by Nir (a money chest)
   *            'welcome-': for Betrophy by Nir (a money chest or a trophy) (!welcome-offer)
   *            '-deal': for Wikiluck by Nir
   *            '-promo': for slotvibe by Kaine Team
   *    - put landing assets to CDN

   ** EXAMPLES from truefortune (rebuild in our testbrand's style): TODO remove all this
   * new design: for games (desktop and mobile)
   - /lp/game-name-50fs-100fc-200wb-upto4000-75btc-fr-eur => works with eliminating the sections (=divided by "-")
   - /lp/game-name-50freespins-100freechips-200bonus-upto4000-75bitcoin-fr-eur => works with eliminating or changing the order of the sections (=divided by "-")
   examples:
   - /lp/50-free-spins-Mandarin-Tiger --> with Nir for Avantgarde
   - /lp/50-free-spins-majestic-mermaid
   - /lp/20fc-onlucky-ox-jackpots-400wb-upto2000
   - /lp/25-free-chips-diamond-dragon
   - /lp/100-free-spins-klondike-gold
   * old ones almost rebuilt: with only a background image
   - /lp/10-free-spins
   - /lp/10-free-spins-e
   */

//todo: refactor scss - .text-shadow class not rival brands where needed + highlighted flares on almost all nir-landings


  assetsPath:string;
  brand: string;
  logoFileName: string;
  logoAltText: string;

  footerLogos: { name: string, filename: string }[] = [];

  terms: boolean = false;
  pageId: string = '';
  landing?: LandingModel;

  gameName?: string;
  gamePromoPaths?: GamePromoModel;
  backgroundStyles: {} = {};
  promoImageStyles: {} = {};

  isLoading:boolean = false; //a loader on button clicked because dela redirect is very slow (+slotvibe)


  constructor(
    private configs: ConfigService,
    private route: ActivatedRoute,
    private landingService: LandingService,
    private langService: LanguageService,
    private router: Router,
    private titleService: TitleService
  ) {
    this.assetsPath = this.configs.assetsPath;
    this.brand = this.configs.name;
    this.logoFileName = this.configs.logoName;
    this.logoAltText = this.configs.logoAltText;
    this.footerLogos = this.landingService.allFooterLogos;

    this.titleService.setTitle('Landing Page');

  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.pageId = params['pageId'];

      if (this.pageId) {
        // new landing - only gamePromos with animated bg and promo image
        // maybe later: an onlyBg landing page, ex, redesigned old ones - maybe we will never need this

        this.pageId = this.pageId.toLowerCase();

        this.getDetailsFromTheUrl();

        //get the view if it is a gamePromo
        if (this.gamePromoPaths){
          this.promoImageStyles = this.getPromoImageFlares();
        }
        this.backgroundStyles = this.getBackgroundStyles();

        //footerLogos are all the same for affiliated brands (we have them from the constructor) or
        // this.footerLogos = this.landingService.footerLogosByCasino[this.brand as keyof typeof this.landingService.footerLogosByCasino] ?? []
        //for slotvibe: no footerlogos
        if (this.assetsPath.includes('slotvibe')){
          this.footerLogos = []
        }

        this.isLoading = false;

      }
      if (!this.landing) {
        //navigate to the website if the pageid is missing (any other routes than l/pageid)
        this.goToRegistration()
      }

      // console.log(this.gameName)
    });
  }

  private getDetailsFromTheUrl() {

    const gameName = this.getGameFromUrl();  //gets gameName and gamePromoPaths
    const freeSpins = this.getFreeSpinsFromUrl();
    const freeChips = this.getFreeChipsFromUrl();
    const freeBets = this.getFreeBetsFromUrl();
    const bonus = this.getBonusFromUrl();
    const limit = this.getLimitFromUrl();
    const bonuscode = this.getBonuscodeFromUrl();
    // const bitcoin = this.getBitcoinFromUrl(); //we dont use it, so removed - gives the top bitcoin line
    const currency = this.getCurrencyFromUrl();
    const language = this.getLanguageFromUrl();

    if (language) {
      this.langService.setUserSelectedLang(language);
    }

    //we only have gamePromos as new design Landings - if its not a gameLPromo, redirected to home/instantplay
    if(this.gamePromoPaths){
      this.landing = {
        id: this.pageId,
        offer: {
          fs: freeSpins,
          fc: freeChips,
          fb: freeBets,
          wb: {
            amount: bonus,
            limit: limit
          },
          btc: 0,
          // btc: bitcoin ?? 0,
          bonuscode: bonuscode
        },
        game: gameName,
        language: language,
        currency: currency ?? undefined
      }
      if (this.assetsPath.includes('slotvibe')){
        this.landing.stylingClass = 'slotvibe-general'
      }
      if (this.assetsPath.includes('24slots')|| this.assetsPath.includes('betrophy')|| this.assetsPath.includes('wikiluck')){
        this.landing.stylingClass = 'dela'
      }
      //to have the flares on the top of the promo image for some games - todo find out if it goes for all nir landings
      const landingsWhereFlaresGoesFirst = ["midnight-mustang", "888-dream-dragon", "crazy-clover-cash", "jenny-nevada", "super-hoopers"]
      if(this.gameName && landingsWhereFlaresGoesFirst.includes(this.gameName)){
        if (this.landing.stylingClass){
          //for slotvibe and dela landings
          this.landing.stylingClass += ' highlighted-flares'
        } else {
          this.landing.stylingClass = 'highlighted-flares'
        }
        // console.log(this.landing.stylingClass)
      }
      // if(this.gameName === 'midnight-mustang' || this.gameName === '888-dream-dragon' || this.gameName === 'crazy-clover-cash'){
      //   if (this.landing.stylingClass){
      //     //for slotvibe and dela landings
      //     this.landing.stylingClass += ' highlighted-flares'
      //   } else {
      //     this.landing.stylingClass = 'highlighted-flares'
      //   }
      // }
    }
    //maybe later: else make an only bg landing

    //currently hidden more-info terms modal
    // this.terms = this.pageId.includes('terms')

    // console.log(this.landing?.offer)

  }


  getBackgroundStyles() {
    // for landings with gamePromo - get the flares dynamically
    const bg: string = this.gamePromoPaths
      ? `url(assets/landingPages/game_promos/${this.gamePromoPaths.game_name}/${this.gamePromoPaths.background_image})`
      : 'none'

    const { flares1, flares2 } = this.getBgFlares();

    return {
      'background-image': bg,
      '--flare-img-1': flares1,
      '--flare-img-2': flares2
    }

  }

  getPromoImageFlares() {
    //in gamePromoPaths.promo_img, the first element is the promo image and what comes after are the flares
    if (this.gamePromoPaths && this.gamePromoPaths.promo_img.length > 1) {

      const flares = this.gamePromoPaths.promo_img.slice(1)
        .filter(flare => flare) //to filter out empty strings, undefined or null values
        .map(flare => `url(assets/landingPages/game_promos/${this.gamePromoPaths!.game_name}/${flare})`)

      if (flares.length) {
        let flares1array: string[] = [];
        let flares2array: string[] = [];

        flares.forEach((flare, i) => {
          if (i % 2 === 0) {
            flares1array.push(flare);
          } else {
            flares2array.push(flare);
          }
        });

        return {
          '--promo-flare-img1': flares1array.length ? flares1array.join(", ") : 'none',
          '--promo-flare-img2': flares2array.length ? flares2array.join(", ") : 'none'
        }
      }
    }
    return {flares1: 'none', flares2: 'none'}
  }

  getBgFlares() {
    if (this.gamePromoPaths && this.gamePromoPaths.flares.length) {

      const flares = this.gamePromoPaths.flares
        .filter(flare => flare) //to filter out empty strings, undefined or null values
        .map(flare => `url(assets/landingPages/game_promos/${this.gamePromoPaths!.game_name}/${flare})`)

      if (flares.length) {
        let flares1array: string[] = [];
        let flares2array: string[] = [];

        flares.forEach((flare, i) => {
          if (i % 2 === 0) {
            flares1array.push(flare);
          } else {
            flares2array.push(flare);
          }
        });

        return {
          flares1: flares1array.length ? flares1array.join(", ") : 'none',
          flares2: flares2array.length ? flares2array.join(", ") : 'none'
        }
      }
    }
    return {flares1: 'none', flares2: 'none'}
  }




  private getGameFromUrl() {
    // if we have a game-name saved in service with gamePromoPaths saved in assets
    const gamePromo = this.landingService.getGamePromoPaths().find(g => this.pageId.includes(g.game_name))
    if (gamePromo) {
      this.gameName = gamePromo.game_name;
      this.gamePromoPaths = gamePromo;
    }
    return this.gameName;
  }

  getFreeSpinsFromUrl(): number {
    const spinsKeywords = ['free-spin', 'freespin', 'fs'];

    for (const keyword of spinsKeywords) {
      const keywordIndex = this.pageId.indexOf(keyword);
      if (keywordIndex !== -1) {
        return this.getNumberBeforeKeywordFromUrl(keyword);
      }
    }
    return 0;
  }

  getFreeChipsFromUrl(): number {
    const chipKeywords = ['free-chip', 'freechip', 'fc'];

    for (const keyword of chipKeywords) {
      const keywordIndex = this.pageId.indexOf(keyword);
      if (keywordIndex !== -1) {
        return this.getNumberBeforeKeywordFromUrl(keyword);
      }
    }
    return 0;
  }

  getFreeBetsFromUrl(): number {
    const betKeywords = ['free-bet', 'freebet', 'fb'];

    for (const keyword of betKeywords) {
      const keywordIndex = this.pageId.indexOf(keyword);
      if (keywordIndex !== -1) {
        return this.getNumberBeforeKeywordFromUrl(keyword);
      }
    }
    return 0;
  }

  getBonusFromUrl(): number {
    const bonusKeywords = ['bonus-', 'wb', 'welcome-bonus'];

    for (const keyword of bonusKeywords) {
      const keywordIndex = this.pageId.indexOf(keyword);
      if (keywordIndex !== -1) {
        return this.getNumberBeforeKeywordFromUrl(keyword);
      }
    }
    return 0;
  }

  getLimitFromUrl(): number {
    //if there is a limit in url - after these keywords
    const limitKeywords = ['upto', 'up-to'];

    for (const keyword of limitKeywords) {
      const keywordIndex = this.pageId.indexOf(keyword);
      if (keywordIndex !== -1) {
        const substringAfterKeyword = this.pageId.slice(keywordIndex + keyword.length);
        // Match the first number that appears after the keyword
        const matches = substringAfterKeyword.match(/\d+/);
        if (matches) {
          return this.convertToDecimal(matches[0])
        }
      }
    }
    return 0;
  }

  getBonuscodeFromUrl(): string | undefined {
    //if there is bonuscode in url:
    const keyWordIndex = this.pageId.indexOf("bonuscode");
    if (keyWordIndex !== -1) {
      // return "CMB20";
      const sectionsInPageId = this.pageId.split('-')
      const bonuscodeIndex = sectionsInPageId.indexOf("bonuscode")
      if (bonuscodeIndex !== -1) {
        const code = sectionsInPageId[bonuscodeIndex + 1] //the word after 'bonuscode'
        if(code){
          return code
        }
        return "CMB20"
      }

    }
    return undefined;
  }

  getBitcoinFromUrl(): number | undefined {
    const bonusKeywords = ['btc', 'bitcoin'];
    for (const keyword of bonusKeywords) {
      const fcIndex = this.pageId.indexOf(keyword);
      if (fcIndex !== -1) {
        return this.getNumberBeforeKeywordFromUrl(keyword);
      }
    }
    return undefined;
  }

  getCurrencyFromUrl(): string | undefined {
    const currencyOptions = ['eur', 'usd', 'gbp', 'aud', 'nzd', 'zar', 'cad', 'cdn', 'dollar', 'btc'];

    for (const keyword of currencyOptions) {
      const keywordIndex = this.pageId.indexOf(keyword);
      if (keywordIndex !== -1) {
        switch (keyword) {
          case 'euro':
            return 'EUR';
          case 'dollar':
            return 'USD'
          case 'cdn':
            return 'CAD'
          default:
            return keyword.toUpperCase()
        }
      }
    }
    return undefined;
  }

  getLanguageFromUrl(): string {
    const langOptions: string[] = this.langService.languageOptions.map(lang => lang.value);

    const segments = this.pageId.split('-');
    for (let i = 0; i < segments.length; i++) {
      if (langOptions.includes(segments[i])) {
        return segments[i]
      }
    }
    return 'en';
  }

  getNumberBeforeKeywordFromUrl(word: string): number {

    const keywordIndex = this.pageId.indexOf(word);

    // If the keyword is not found, return 0
    if (keywordIndex === -1) {
      return 0;
    }

    // Find all numbers before the keyword
    const substringBeforeKeyword = this.pageId.slice(0, keywordIndex);
    const matches = substringBeforeKeyword.match(/\d+/g);
    // If matches are found, return the last one, that will be the one before the keyword
    if (matches) {
      return Number(matches[matches.length - 1]);
    } else {
      return 0;
    }
  }

  goToRegistration(): void {
    this.isLoading = true;

    if (this.brand === '24slots'){
      window.location.href = "https://24slots.online/online-casino?register=true";
    } else if (this.brand === 'betrophy' && this.gameName?.includes('sports')){
      window.location.href = "https://betrophy.co/hu/sports?register=true";
    } else if (this.brand === 'betrophy'){
      window.location.href = "https://betrophy.co/?register=true";
    } else if (this.brand === 'wikiluck'){
      window.location.href = "https://wikiluck.co/?register=true";
    } else if (this.brand === 'slotvibe'){
      window.location.href="https://www.slotvibe.com/?sign-up=modal";
    } else if (this.landing && this.landing.language){
      if (this.landing.language === 'en') {
        this.router.navigate(['instantplay'])
      } else {
        this.router.navigate([`${this.landing.language}`, 'instantplay'])
      }
    }
  }

  toggleInfoModal(): void {
    if (this.terms){
      //deactivate Bootstrap modals preventing text input fields focus
      bootstrap.Modal.prototype._initializeFocusTrap = function () { return { activate: function () { }, deactivate: function () { } } };

      const infoModal = new bootstrap.Modal(document.getElementById('infoModal'), {})
      infoModal.show()
    }
  }

  copyCode(){
    if (this.landing?.offer.bonuscode) {
      if (navigator.clipboard){
        navigator.clipboard.writeText(this.landing?.offer.bonuscode.toUpperCase())
        .then(() => {
          // console.log('Text copied!')
          alert('Text copied to clipboard')
        })
        .catch(err => console.log(`Error copying text: , ${err}`));
      } else {
        // Fallback for older iOS or when Clipboard API is not available
        const textArea = document.createElement('textarea');
        textArea.value = this.landing.offer.bonuscode.toUpperCase();
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        alert('Copied the code.');
      }
    }
  }

  convertToDecimal(numStr: string): number {
    // Remove leading zeros and get the remaining number
    const trimmedNum = numStr.replace(/^0+/, '');
    const numOfleadingZeros = numStr.length - trimmedNum.length;

    if (numOfleadingZeros === 0) {
      return Number(numStr);
    }
    const divisor = Math.pow(10, numOfleadingZeros);
    return Number(trimmedNum) / divisor;
  }


}

